import { ApiMembership } from '@tytapp/api';

export const EXPIRING_STATUSES = ['expiring', 'expired', 'canceling', 'canceled'];

export function isExpiring(membership: ApiMembership | undefined) {
    return EXPIRING_STATUSES.includes(membership?.payment_status);
}

export function isPastRenewal(membership: ApiMembership | undefined, now = Date.now()) {
    if (!membership)
        return false;
    if (membership.payment_status == 'good_standing')
        return false;

    return new Date(membership.renews_on).getTime() < now;
}

export const MEMBERSHIP_PROPERTY_HELPER = {
    isExpiring
}